import { useEffect,  useState, useTransition } from "react";
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { Badge, Input, Select } from "antd";
import { useOutletContext } from "react-router-dom";
import IsLoading from "../../common/isLoading";
import Card from "./card";

const Equipment = () => {
    const [filteredList, setFilteredList] = useState([]);
    const { refresh, isLoading, setIsLoading, getItems, equipmentList, getEquipment, editEquipment, viewEquipment } = useOutletContext();
    const [searchInput, setSearchInput] = useState('');
    const [filterBy, setFilterBy] = useState('Active');
    const [isPending, startTransition] = useTransition();

    useEffect(() => {
        Init();    
    }, [refresh])

    const Init = async () => {
        setIsLoading(true);
        const response = await getEquipment();
        await getItems();
        setFilteredList(response);
        filterData(response);
        setIsLoading(false);
    }

      useEffect(() => {
       filterData(equipmentList);
    }, [searchInput,filterBy])

    const filterData = (List) => {
        startTransition(() => {
            const query = (searchInput || "").toLowerCase();
            let searchedList = List.filter(item =>
                (item.unit || "").toString().toLowerCase().includes(query) ||
                (item.plate || "").toString().toLowerCase().includes(query)
                //(item.vin || "").toString().toLowerCase().includes(query)
            );
            if (filterBy !== '')
                searchedList = searchedList.filter(item => (item.status || "").includes(filterBy))

            setFilteredList(searchedList);
        })
    }

    return (
        <div class="flex flex-col font-normal w-full h-screen bg-gray-100 relative" >

            {/* Header */}
            <div className="bg-blue-500 p-5 text-white  rounded-b-2xl sticky top-0 z-50 ">
                <div className="flex justify-between items-center mb-4">
                    <span> </span>
                    <h1 className="font-semibold text-lg">
                        Equipment List
                    </h1>
                    <PlusOutlined size={22} className="cursor-pointer" onClick={() => editEquipment(0)} />
                </div>

                <div className="flex gap-2">
                    <Input size="large" style={{ fontSize: 16 }} placeholder="Search" prefix={<SearchOutlined />} value={searchInput} onChange={(e) => setSearchInput(e.target.value)} allowClear />
                    <Select
                        value={filterBy}
                        style={{ width: 120, fontSize: 16 }}
                        onChange={(e) => setFilterBy(e)}
                        options={[
                            { value: '', label: <Badge color={'blue'} text={'All'} /> },
                            { value: 'Active', label: <Badge color={'green'} text={'Active'} /> },
                            { value: 'Inactive', label: <Badge color={'red'} text={'Inactive'} /> }
                        ]}
                    />
                </div>
            </div>

            {/* Content */}
            <IsLoading isLoading={isLoading || isPending} rows={10} input={
                <div className="p-4 space-y-4 overflow-y-auto h-[calc(100%-180px)]" >
                    {
                        filteredList.length === 0 ?
                            <div className="flex justify-between items-center mt-2 text-xs text-gray-400">
                                <span>No data found</span>

                            </div> :
                            filteredList.map((item) => (
                                <Card
                                    id={item.id}
                                    user={item.user}
                                    title={item.unit}
                                    description={item.plate}
                                    make={item.make}
                                    model={item.model}
                                    year={item.year}
                                    status={item.status}
                                    notes={item.notes}
                                    modifiedat={item.modifiedat}
                                    picture={item.picture}
                                    equipment={viewEquipment}
                                    isEdit={false}

                                />
                            ))}

                </div>
            } />
        </div>
    )
}

export default Equipment